'use client';

import { useEffect, useRef } from 'react';
import { registerFcmToken } from '@/app/_libs/notifications';
import { useAuthStore, type AuthStore } from '@/stores/auth-store';

export function AdminFcmRegistrationHandler() {
  const userId = useAuthStore((state: AuthStore) => state.user?.id ?? null);
  const lastRegisteredUserId = useRef<string | null>(null);

  useEffect(() => {
    if (!userId) {
      lastRegisteredUserId.current = null;
      return;
    }

    if (lastRegisteredUserId.current === userId) return;
    lastRegisteredUserId.current = userId;

    registerFcmToken().catch((error: unknown) => {
      console.error('FCM registration failed:', error);
    });
  }, [userId]);

  return null;
}
